// @ts-nocheck
// noinspection ES6ConvertVarToLetConst,JSDeprecatedSymbols,SpellCheckingInspection,EqualityComparisonWithCoercionJS

// based on - https://telegram.org/js/telegram-web-app.js

function urlSafeDecode(urlencoded) {
  try {
    urlencoded = urlencoded.replace(/\+/g, '%20')
    return decodeURIComponent(urlencoded)
  } catch (e) {
    return urlencoded
  }
}

// @ts-ignore
function urlParseQueryString(queryString) {
  var params = {}
  if (!queryString.length) {
    return params
  }
  var queryStringParams = queryString.split('&')
  var i, param, paramName, paramValue
  for (i = 0; i < queryStringParams.length; i++) {
    param = queryStringParams[i].split('=')
    paramName = urlSafeDecode(param[0])
    paramValue = param[1] == null ? null : urlSafeDecode(param[1])
    params[paramName] = paramValue
  }
  return params
}

function urlParseHashParams(locationHash: string) {
  locationHash = locationHash.replace(/^#/, '')
  var params = {}
  if (!locationHash.length) {
    return params
  }
  if (locationHash.indexOf('=') < 0 && locationHash.indexOf('?') < 0) {
    params._path = urlSafeDecode(locationHash)
    return params
  }
  var qIndex = locationHash.indexOf('?')
  if (qIndex >= 0) {
    var pathParam = locationHash.substring(0, qIndex)
    params._path = urlSafeDecode(pathParam)
    locationHash = locationHash.substring(qIndex + 1)
  }
  var query_params = urlParseQueryString(locationHash)
  for (var k in query_params) {
    params[k] = query_params[k]
  }
  return params
}

export function getTgWebAppData(hash?: string): string {
  const initParams = urlParseHashParams(hash || '')
  return initParams.tgWebAppData || ''
}

function findHashFromEntry(): string | undefined {
  try {
    const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
    if (!entry) return

    const index = entry.name.indexOf('#')
    if (index < 0) return

    const hash = entry.name.substring(index)
    if (hash.includes('tgWebApp')) return hash
  } catch (e) {
    console.error(e)
  }
}

export function getLocationHash(): string {
  const telegram = 'TelegramWebviewProxy' in window
  if (telegram) {
    const entry = findHashFromEntry()
    if (entry) return entry
  }
  return window.location.href
}
